import { ReactNode } from 'react';

import useFetchTrigger from 'components/domain/automation/triggers/useFetchTrigger';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';

interface TriggerNameProps {
  formatName?: (name: string) => ReactNode;
  triggerUid: string | null;
}

const TriggerName = ({ formatName, triggerUid }: TriggerNameProps) => {
  const { data: trigger, isLoading } = useFetchTrigger({ triggerUid });

  if (isLoading) {
    <LoadingPlaceholder />;
  }

  if (!trigger) {
    return '-';
  }

  if (formatName) {
    return formatName(trigger.name);
  }

  return trigger.name;
};

export default TriggerName;
